// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1BYX5","selected":"Chip_selected__3USql"};